<template>
  <div
    @click="$emit('onClick')"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="w-full flex flex-wrap content-end h-12 cursor-pointer"
  >
    <div
      class="w-full flex items-center cursor-pointer"
    >
      <div
        :class="customCssLine"
        class="w-full border-t transition-all ease-in-out duration-300"
      >
      </div>
    </div>
    <button
      class="flex justify-start items-center focus:outline-none text-sm uppercase font-sansBold"
      :class="customCssButton"
      :disabled="disabled"
      :type="type"
      :id="id"
    >
      <slot>
        CustomButton
      </slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CustomButtonTwo',
  props: {
    id: String,
    type: {
      type: String,
      default: 'button'
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCssButton: function () {
      var toReturn = ''
      if (this.dark) toReturn += ' text-black '
      else toReturn += ' text-white  '

      return toReturn
    },
    customCssLine: function () {
      var toReturn = ''

      if (this.dark) toReturn += ' border-black'
      else toReturn += ' border-white '

      if (!this.disabled) {
        if (!this.hovered) {
          toReturn += ' h-1 '
        } else {
          toReturn += ' h-5 '
        }
      }
      return toReturn
    }
  }
}
</script>
